import 'jspdf-autotable';
import {
  generateExcel,
  HEADER_COLOR,
  functionDidParseCell,
  functionWillDrawCell,
} from './mixin-export';
import alert from 'sweetalert2';
import i18n from 'src/i18n';
import jsPDF from 'jspdf';
import SweetAlert from 'src/class/Alerts';
import Formatter from 'src/class/Formatter';

const mixinExportReport = {
  methods: {
    async exportXLSHeader() {
      SweetAlert.download(
        i18n.t('mix.mixin_export.wait_while_excel_downloads'),
        alert
      );

      setTimeout(async () => {
        const { data, headers } = await this.generateData();
        await generateExcel(
          false,
          i18n.t('labor.report_segregated_by_operator'),
          headers,
          data,
          99,
          ['D', 'H', 'I'],
          {
            columns: ['A', 'B', 'C', 'D'],
            rowspan: this.rowspanInfo,
          }
        );
      }, 1000);
    },

    async exportToPDFHeader() {
      SweetAlert.download(
        i18n.t('mix.mixin_export.wait_while_excel_downloads'),
        alert
      );

      setTimeout(async () => {
        const { data } = await this.generateData(true);
        const columns = [
          { header: i18n.t('labor.worker_code'), dataKey: '0' },
          {
            header: `${i18n.t('common_words.name')} ${i18n.t('labor.worker')}`,
            dataKey: '1',
          },
          {
            header: i18n.t('labor.payment_frequency'),
            dataKey: '2',
          },
          {
            header: `${i18n.t('common_words.total')} ${i18n.t(
              'labor.payment_frequency'
            )}`,
            dataKey: '3',
          },
          { header: i18n.t('common_words.date'), dataKey: '4' },
          {
            header: `${i18n.t('common_words.name')} ${i18n.t(
              'common_words.activity'
            )}`,
            dataKey: '5',
          },
          { header: i18n.t('labor.unit'), dataKey: '6' },
          { header: i18n.t('common_words.quantity'), dataKey: '7' },
          {
            header: i18n.t('common_words.sub_total'),
            dataKey: '8',
          },
        ];
        const doc = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a3',
        });

        let body = [...data];
        const headerStyle = {
          fillColor: HEADER_COLOR,
          textColor: [255, 255, 255],
          fontStyle: 'bold',
          halign: 'left',
        };

        const rowspanInfo = {
          columns: ['0', '1', '2', '3'],
          rowspan: this.rowspanInfo,
        };

        doc.autoTable({
          head: [columns.map((col) => col.header)],
          body: body,
          columns: columns,
          headStyles: headerStyle,
          margin: { top: 20, right: 10, bottom: 20, left: 10 },
          styles: {
            fontSize: 8,
            lineWidth: 0.1,
          },
          bodyStyles: {
            lineWidth: 0.1,
          },
          didParseCell: function (data) {
            functionDidParseCell(data, body, rowspanInfo);
          },
          willDrawCell: function (data) {
            functionWillDrawCell(data, body, rowspanInfo);
          },
        });

        doc.save(`${i18n.t('labor.report_segregated_by_operator')}.pdf`);
        alert.close();
      }, 1000);
    },

    generateData(isForPDF = false) {
      const data = this.tableData.map((header) => {
        const {
          worker_code,
          worker_name,
          payment_period_name,
          total,
          labor_header_date_save,
          activities_name,
          unit_payment_name,
          quantity,
          sub_total,
        } = header;

        return [
          worker_code,
          worker_name,
          payment_period_name,
          isForPDF ? Formatter.formatNumber(Number(total)) : Number(total),
          labor_header_date_save,
          activities_name,
          unit_payment_name,
          quantity,
          isForPDF
            ? Formatter.formatNumber(Number(sub_total))
            : Number(sub_total),
        ];
      });

      const headers = [
        i18n.t('labor.worker_code'),
        `${i18n.t('common_words.name')} ${i18n.t('labor.worker')}`,
        i18n.t('labor.payment_frequency'),
        `${i18n.t('common_words.total')} ${i18n.t('labor.payment_frequency')}`,
        i18n.t('common_words.date'),
        `${i18n.t('common_words.name')} ${i18n.t('common_words.activity')}`,
        i18n.t('labor.unit'),
        i18n.t('common_words.quantity'),
        i18n.t('common_words.sub_total'),
      ];

      return { headers, data };
    },
  },
};

export default mixinExportReport;
